import * as React from 'react'
import PropTypes from 'prop-types'
import { colors, midas } from '@resurs/midas'
import style from '../../shared/transactions.style'
import { getText } from '../../../../internal/TextLabels'
import { ApplicationStatus } from '../../../../models/application-status'
import { ActionTypes } from '../../../../util/transactionConstants'
import { Authorities } from '../../../../models/authorities'
import AuthorizedButton from '../../../../components/Authorized/AuthorizedButton'

export const TransactionCartUIEcomTableHead = ({
  setAction,
  addArticle,
  cartStatus,
  transactionDetails,
}) => {
  return (
    <thead style={{ whiteSpace: 'nowrap' }}>
      <tr style={style.tableHead}>
        <th className={midas.textLeft} key="header-article">
          {getText('transactions.transaction.headers.article')}
        </th>
        <th className={midas.textLeft} key="header-description">
          {getText('transactions.transaction.headers.description')}
        </th>
        <th className={midas.textRight} key="header-inc-vat">
          {getText('transactions.transaction.headers.unitPriceIncVat')}
        </th>
        <th
          className={midas.textCenter}
          key="header-vat"
          style={{ minWidth: '10rem' }}
        >
          {getText('transactions.transaction.headers.vat')}
        </th>
        <th className={midas.textRight} key="header-sum">
          {getText('transactions.transaction.headers.sum')}
        </th>
        <th className={midas.textRight} key="header-vat-sum">
          {getText('transactions.transaction.headers.vatsum')}
        </th>
        <th style={style.tableNumber} key="header-quantity">
          {getText('transactions.transaction.headers.quantity')}
        </th>
        <th
          style={{
            marginLeft: 10,
            color: colors.green1,
            textAlign: 'center',
            borderLeft: '2rem solid white',
            padding: '1rem 0',
          }}
        >
          <AuthorizedButton
            key="debit"
            fullWidth
            type="primary"
            kind="info"
            text={getText('transactions.transaction.action.debit')}
            onClick={() => setAction(ActionTypes.DEBIT)}
            disabled={
              transactionDetails.status === ApplicationStatus.FROZEN ||
              addArticle ||
              (cartStatus && !cartStatus.debitable)
            }
            authority={Authorities.TRANSACTIONS_DEBIT}
            unauthorizedTitle={getText(
              'transactions.transaction.action.unauthorized.debit',
            )}
            dataCy="debit-button"
          />
        </th>
        <th
          style={{
            color: colors.red2,
            textAlign: 'center',
            padding: '1rem 0',
            borderLeft: '1rem solid white',
          }}
        >
          <AuthorizedButton
            key="credit"
            fullWidth
            type="primary"
            kind="info"
            text={getText('transactions.transaction.action.credit')}
            onClick={() => setAction(ActionTypes.CREDIT)}
            disabled={addArticle || (cartStatus && !cartStatus.creditable)}
            authority={Authorities.TRANSACTIONS_CREDIT}
            unauthorizedTitle={getText(
              'transactions.transaction.action.unauthorized.credit',
            )}
            dataCy="credit-button"
          />
        </th>
        <th
          style={{
            color: colors.orange2,
            textAlign: 'center',
            padding: '1rem 0',
            borderLeft: '1rem solid white',
          }}
        >
          <AuthorizedButton
            key="annul"
            type="primary"
            fullWidth
            kind="info"
            text={getText('transactions.transaction.action.annul')}
            onClick={() => setAction(ActionTypes.ANNUL)}
            disabled={addArticle || (cartStatus && !cartStatus.annullable)}
            authority={Authorities.TRANSACTIONS_ANNUL}
            unauthorizedTitle={getText(
              'transactions.transaction.action.unauthorized.annul',
            )}
            dataCy="annul-button"
          />
        </th>
      </tr>
    </thead>
  )
}

TransactionCartUIEcomTableHead.propTypes = {
  setAction: PropTypes.func.isRequired,
  addArticle: PropTypes.bool.isRequired,
  cartStatus: PropTypes.object.isRequired,
  transactionDetails: PropTypes.object.isRequired,
}
